import { Box, Button, Grid, Heading, Icon, Image, Text, VStack, Skeleton } from '@chakra-ui/react';
import React, { useState } from 'react';
import { IoMdCalendar } from 'react-icons/io';
import Nutricionista from '../../../../../../images/dashboard/nutricao.png';
import Cardiologista from '../../../../../../images/dashboard/cardiologista.png';
import Dermatologista from '../../../../../../images/dashboard/dermatologista.png';
import Ortopedista from '../../../../../../images/dashboard/ortopedista.png';
import useModelCardsEspecialista from './useModelCardsEspecialista';
function CardsEspecialistas({ loading, error, especialista, assinante }) {
  const formatBRL = (valor) => {
    if (valor === undefined || valor === null || isNaN(valor)) return '';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }).format(Number(valor));
  };
  const { navigate, setAgendamento, logado } = useModelCardsEspecialista();
  const [imgLoaded, setImgLoaded] = useState({ psicologia: false, nutricionista: false, dermatologista: false, ortopedista: false });

  return (
    <>
      <VStack w="100%" px={{ base: 1, sm: 2, md: 0 }}>
        <Grid
          templateColumns={{ base: '1fr', sm: '1fr 1fr', md: '1fr 1fr', lg: '1fr 1fr' }}
          gap={{ base: 3, sm: 4, md: 6 }}
          width="100%"
          maxWidth="900px"
          mx="auto"
          py={2}
          px={{ base: 1, sm: 2, md: 6 }}
        >
          <Box
            borderRadius="20px"
            overflow="hidden"
            bg="white"
            boxShadow="xl"
            transition="all 0.3s"
            _hover={{ boxShadow: '2xl', transform: 'translateY(-2px)' }}
            onClick={() => {
              navigate('/selecao-pacientes', { state: { tipo: 'especialista', especialidade: 'nutricionista' } });
              setAgendamento((prev) => ({ ...prev, especialidadeId: 54 }));
            }}
          >
            <Box height={{ base: '110px', sm: '140px' }} overflow="hidden" position="relative" mb={0}>
              <Skeleton isLoaded={imgLoaded.nutricionista} height="100%" width="100%" borderRadius="inherit">
                <Image
                  src={Nutricionista}
                  objectFit="cover"
                  width="100%"
                  height="100%"
                  filter="brightness(0.95)"
                  transform="scale(1.13)"
                  objectPosition="top center"
                  onLoad={() => setImgLoaded((prev) => ({ ...prev, nutricionista: true }))}
                />
              </Skeleton>
            </Box>

            <VStack p={4} spacing={3} align="center">
              <Box textAlign="center">
                <Heading as="h3" size={{ base: 'md', sm: 'lg' }} color="#616161" fontWeight="extrabold" noOfLines={2} lineHeight="1.1" m={0} p={0}>
                  Psicologia
                </Heading>
                <Skeleton isLoaded={!loading} mt={0} mb={0}>
                  <Box px={2} py={0} m={0} display="flex" justifyContent="center">
                    <Text as="h3" lineHeight="1" m={0} color={!error ? '#9E9E9E' : 'red'} fontWeight={'semibold'}>
                      {!error ? formatBRL(especialista?.valor_psicologia) : ''}
                    </Text>
                  </Box>
                </Skeleton>
              </Box>

              <Button
                mt={0}
                width={{ base: '100%', sm: '100%', md: '90%' }}
                minWidth={0}
                maxWidth="100%"
                bg="#5AB2AE"
                color="white"
                leftIcon={<Icon as={IoMdCalendar} boxSize={{ base: 4, sm: 5 }} />}
                _hover={{ bg: '#5AB2AE' }}
                borderRadius="full"
                whiteSpace="normal"
                display="flex"
                justifyContent="center"
                alignItems="center"
                fontSize="0.8em"
                px={{ base: 2, sm: 4, md: 6 }}
                py={{ base: 2, sm: 2, md: 3 }}
                textAlign="center"
              >
                Agendar Consulta
              </Button>
            </VStack>
          </Box>
          <Box
            borderRadius="20px"
            overflow="hidden"
            bg="white"
            boxShadow="xl"
            transition="all 0.3s"
            _hover={{ boxShadow: '2xl', transform: 'translateY(-2px)' }}
            onClick={() => {
              navigate('/selecao-pacientes', { state: { tipo: 'especialista', especialidade: 'psicologia' } });
              setAgendamento((prev) => ({ ...prev, especialidadeId: 61 }));
            }}
          >
            <Box height={{ base: '110px', sm: '140px' }} overflow="hidden" position="relative" mb={0}>
              <Skeleton isLoaded={imgLoaded.psicologia} height="100%" width="100%" borderRadius="inherit">
                <Image
                  src={Cardiologista}
                  objectFit="cover"
                  width="100%"
                  height="100%"
                  filter="brightness(0.95)"
                  transform="scale(1.13)"
                  objectPosition="top center"
                  onLoad={() => setImgLoaded((prev) => ({ ...prev, psicologia: true }))}
                />
              </Skeleton>
            </Box>

            <VStack p={4} align="center">
              <Box textAlign="center">
                <Heading as="h3" size={{ base: 'md', sm: 'lg' }} color="#616161" fontWeight="extrabold" noOfLines={2} lineHeight="1.1" m={0} p={0}>
                  Nutrição
                </Heading>
                <Skeleton isLoaded={!loading} mt={0} mb={0}>
                  <Box px={2} py={0} m={0} display="flex" justifyContent="center">
                    <Text as="h3" lineHeight="1" m={0} color={!error ? '#9E9E9E' : 'red'} fontWeight={'semibold'}>
                      {!error ? formatBRL(especialista?.valor_nutricionista) : ''}
                    </Text>
                  </Box>
                </Skeleton>
              </Box>

              <Button
                mt={0}
                width={{ base: '100%', sm: '100%', md: '90%' }}
                minWidth={0}
                maxWidth="100%"
                bg="#5AB2AE"
                color="white"
                leftIcon={<Icon as={IoMdCalendar} boxSize={{ base: 4, sm: 5 }} />}
                _hover={{ bg: '#5AB2AE' }}
                borderRadius="full"
                whiteSpace="normal"
                display="flex"
                justifyContent="center"
                alignItems="center"
                fontSize="0.8em"
                px={{ base: 2, sm: 4, md: 6 }}
                py={{ base: 2, sm: 2, md: 3 }}
                textAlign="center"
              >
                Agendar Consulta
              </Button>
            </VStack>
          </Box>
          <Box
            borderRadius="20px"
            overflow="hidden"
            bg="white"
            boxShadow="xl"
            transition="all 0.3s"
            _hover={{ boxShadow: '2xl', transform: 'translateY(-2px)' }}
            onClick={() => {
              navigate('/selecao-pacientes', { state: { tipo: 'especialista', especialidade: 'nutricionista' } });
              setAgendamento((prev) => ({ ...prev, especialidadeId: 57 }));
            }}
          >
            <Box height={{ base: '110px', sm: '140px' }} overflow="hidden" position="relative" mb={0}>
              <Skeleton isLoaded={imgLoaded.dermatologista} height="100%" width="100%" borderRadius="inherit">
                <Image
                  src={Dermatologista}
                  objectFit="cover"
                  width="100%"
                  height="100%"
                  filter="brightness(0.95)"
                  transform="scale(1.13)"
                  objectPosition="top center"
                  onLoad={() => setImgLoaded((prev) => ({ ...prev, dermatologista: true }))}
                />
              </Skeleton>
            </Box>

            <VStack p={4} spacing={3} align="center">
              <Box textAlign="center">
                <Heading as="h3" size={{ base: 'md', sm: 'lg' }} color="#616161" fontWeight="extrabold" noOfLines={2} lineHeight="1.1" m={0} p={0}>
                  Dermatologia
                </Heading>

                <Skeleton isLoaded={!loading} mt={0} mb={0}>
                  <Box px={2} py={0} m={0} display="flex" justifyContent="center">
                    <Text as="h3" lineHeight="1" m={0} color={!error ? '#9E9E9E' : 'red'} fontWeight={'semibold'}>
                      {!error ? formatBRL(especialista?.valor_dermatologista) : ''}
                    </Text>
                  </Box>
                </Skeleton>
              </Box>
              <Button
                mt={0}
                width={{ base: '100%', sm: '100%', md: '90%' }}
                minWidth={0}
                maxWidth="100%"
                bg="#5AB2AE"
                color="white"
                leftIcon={<Icon as={IoMdCalendar} boxSize={{ base: 4, sm: 5 }} />}
                _hover={{ bg: '#5AB2AE' }}
                borderRadius="full"
                whiteSpace="normal"
                display="flex"
                justifyContent="center"
                alignItems="center"
                fontSize="0.8em"
                px={{ base: 2, sm: 4, md: 6 }}
                py={{ base: 2, sm: 2, md: 3 }}
                textAlign="center"
              >
                Agendar Consulta
              </Button>
            </VStack>
          </Box>
          <Box
            borderRadius="20px"
            overflow="hidden"
            bg="white"
            boxShadow="xl"
            transition="all 0.3s"
            _hover={{ boxShadow: '2xl', transform: 'translateY(-2px)' }}
            onClick={() => {
              setAgendamento((prev) => ({ ...prev, especialidadeId: 65 }));
              navigate('/selecao-pacientes', { state: { tipo: 'especialista', especialidade: 'ortopedista' } });
            }}
          >
            <Box height={{ base: '110px', sm: '140px' }} overflow="hidden" position="relative" mb={0}>
              <Skeleton isLoaded={imgLoaded.ortopedista} height="100%" width="100%" borderRadius="inherit">
                <Image
                  src={Ortopedista}
                  objectFit="cover"
                  width="100%"
                  height="100%"
                  filter="brightness(0.95)"
                  transform="scale(1.13)"
                  objectPosition="top center"
                  onLoad={() => setImgLoaded((prev) => ({ ...prev, ortopedista: true }))}
                />
              </Skeleton>
            </Box>

            <VStack p={4} spacing={3} align="center">
              <Box textAlign="center">
                <Heading as="h3" size={{ base: 'md', sm: 'lg' }} color="#616161" fontWeight="extrabold" noOfLines={2} lineHeight="1.1" m={0} p={0}>
                  Ortopedia
                </Heading>

                <Skeleton isLoaded={!loading} mt={0} mb={0}>
                  <Box px={2} py={0} m={0} display="flex" justifyContent="center">
                    <Text as="h3" lineHeight="1" m={0} color={!error ? '#9E9E9E' : 'red'} fontWeight={'semibold'}>
                      {!error ? formatBRL(especialista?.valor_ortopedista) : ''}
                    </Text>
                  </Box>
                </Skeleton>
              </Box>
              <Button
                mt={0}
                width={{ base: '100%', sm: '100%', md: '90%' }}
                minWidth={0}
                maxWidth="100%"
                bg="#5AB2AE"
                color="white"
                leftIcon={<Icon as={IoMdCalendar} boxSize={{ base: 4, sm: 5 }} />}
                _hover={{ bg: '#5AB2AE' }}
                borderRadius="full"
                whiteSpace="normal"
                display="flex"
                justifyContent="center"
                alignItems="center"
                fontSize="0.8em"
                px={{ base: 2, sm: 4, md: 6 }}
                py={{ base: 2, sm: 2, md: 3 }}
                textAlign="center"
              >
                Agendar Consulta
              </Button>
            </VStack>
          </Box>
        </Grid>
        <Box w="100%" maxWidth="900px" mx="auto" display="flex" justifyContent="flex-end" mt={2} px={{ base: 1, sm: 2, md: 6 }}>
          <Button
            bg="none"
            color="#5AB2AE"
            variant="ghost"
            rightIcon={<span>→</span>}
            fontSize={{ base: 'sm', sm: 'md', md: 'lg' }}
            px={{ base: 2, sm: 4, md: 6 }}
            onClick={() => {
              navigate('/selecao-pacientes', { state: { tipo: 'especialista', especialidade: '' } });
              setAgendamento((prev) => ({ ...prev, especialidadeId: null }));
            }}
          >
            Ver todas
          </Button>
        </Box>
      </VStack>
    </>
  );
}

export default CardsEspecialistas;
